import keyboardKeyPolyfill from "keyboardevent-key-polyfill";
import formatToParts from "@/lib/polyfills/FormatToParts";

keyboardKeyPolyfill.polyfill();
formatToParts.polyfill();
